/* src/app/modules/invoice/preinvoice/preinvoice.component.css */
.contact-tooltip-red {
  background: #b71c1c !important;
}
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
ul {
  list-style-type: none;
}
.conceptsList {
  height: 300px;
  overflow-x: auto;
}
table thead tr {
  background: #e3fd64;
}
tfoot {
  background-color: #343a40;
  color: white;
}
.fi-dialog-header {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem 0.75rem !important;
  margin: 0 !important;
  border-bottom: 1px solid #f0f0f0;
}
.fi-dialog-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: #1f2937;
}
.fi-dialog-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}
.fi-dialog-icon mat-icon {
  color: #e3fd64;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.fi-close-btn {
  color: #9ca3af;
}
.fi-content {
  padding: 1.25rem 1.25rem 0.5rem !important;
  max-height: 70vh;
}
.fi-prefix-icon,
.fi-suffix-icon {
  font-size: 18px;
  color: #9ca3af;
}
.fi-checkbox {
  padding-top: 0.25rem;
}
.fi-taxes-section {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  background: #fafafa;
}
.fi-taxes-label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 0.6rem;
}
.fi-taxes-label mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #9ca3af;
}
.fi-chips-wrap {
  margin-top: 0.5rem;
}
.fi-total-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background:
    linear-gradient(
      135deg,
      #fff8e6 0%,
      #fff3d6 100%);
  border: 1px solid #e3fd64;
  border-radius: 8px;
  padding: 0.75rem 1.25rem;
}
.fi-total-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #92400e;
}
.fi-total-value {
  font-size: 1.3rem;
  font-weight: 700;
  color: #92400e;
  letter-spacing: -0.01em;
}
.fi-actions {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.25rem 1rem !important;
  border-top: 1px solid #f0f0f0;
  gap: 0.5rem;
}
.fi-action-secondary {
  color: #6b7280;
}
.fi-actions-right {
  display: flex;
  gap: 0.5rem;
}
@media (max-width: 560px) {
  .fi-content {
    min-width: unset;
    padding: 1rem !important;
  }
}
:host ::ng-deep .rr-field-full {
  width: 100% !important;
}
.rr-form {
  padding-bottom: 2rem;
}
.tf-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0 1.25rem;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 1.5rem;
}
.tf-page-title {
  font-weight: 700;
  font-size: 1.4rem;
  color: #1f2937;
  margin: 0;
}
.tf-card mat-card-content {
  padding: 1.25rem !important;
}
.tf-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
}
.tf-section-title {
  font-weight: 600;
  font-size: 1rem;
  color: #1f2937;
  margin: 0;
}
.sv-field-help {
  display: flex;
  align-items: flex-start;
  gap: 0.25rem;
}
.sv-field-help mat-form-field {
  flex: 1;
  min-width: 0;
}
.sv-field-help app-help {
  flex-shrink: 0;
  margin-top: 0.8rem;
}
.tf-lines-wrap {
  overflow-x: auto;
}
.tf-line {
  display: grid;
  grid-template-columns: 3fr 55px 90px 65px 2fr 105px 88px;
  align-items: center;
  column-gap: 0.5rem;
  padding: 0.4rem 0.75rem;
}
.tf-line--header {
  background: #f8f9fa;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 0.5rem;
}
.tf-line--data {
  background: #fff;
  transition: box-shadow 0.15s ease;
  padding-top: 0.55rem;
  padding-bottom: 0.55rem;
  margin-bottom: 0.35rem;
}
.tf-line--data:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.tf-cell-label {
  display: none;
  font-size: 0.72rem;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: .03em;
}
.tf-line-actions {
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 767px) {
  .tf-line--header {
    display: none;
  }
  .tf-line--data {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    padding: 0.75rem 1rem;
  }
  .tf-line--data .tf-cell {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    font-size: 0.9rem;
  }
  .tf-cell-label {
    display: inline;
  }
  .tf-line-actions {
    justify-content: flex-end;
    margin-top: 0.25rem;
  }
}
.tf-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1rem;
  color: #9ca3af;
}
.tf-empty-state mat-icon {
  font-size: 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  margin-bottom: 0.5rem;
  opacity: 0.4;
}
.tf-empty-state p {
  margin: 0;
  font-size: 0.9rem;
}
.tf-summary {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 1rem 1.25rem;
  background: #fafafa;
}
.tf-summary-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #374151;
  padding: 4px 0;
}
.tf-summary-divider {
  border-top: 1px solid #e5e7eb;
  margin: 0.5rem 0;
}
.tf-summary-row--total {
  font-weight: 700;
  font-size: 15px;
  color: #111827;
}
.tf-summary-row--total span:last-child {
  font-size: 16px;
}
.ef-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: var(--cf-bg, #f4f6f8);
  font-family: "Inter Tight", sans-serif;
}
.ef-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 24px;
  background: var(--cf-surface, #fff);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
}
.ef-header__icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ef-header__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: var(--cf-brand-dark);
}
.ef-header__title {
  margin: 0 0 2px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--cf-text, #1a1d23);
  line-height: 1.3;
}
.ef-header__sub {
  margin: 0;
  font-size: 0.78rem;
  color: var(--cf-text-muted, #6b7280);
}
.ef-header__summary {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 16px;
  background: var(--cf-bg, #f4f6f8);
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius, 8px);
  padding: 8px 16px;
}
.ef-header__summary-divider {
  width: 1px;
  height: 28px;
  background: var(--cf-border, #e5e7eb);
}
.ef-header__summary-item {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.ef-header__summary-label {
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cf-text-muted, #6b7280);
}
.ef-header__summary-value {
  font-size: 0.925rem;
  font-weight: 600;
  color: var(--cf-text, #1a1d23);
  font-variant-numeric: tabular-nums;
}
.ef-header__summary-value--total {
  font-size: 1.05rem;
  color: var(--cf-brand-dark, #4d7a00);
}
.ef-btn-save {
  background: var(--cf-brand, #e3fd64) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(227, 253, 100, 0.25) !important;
  white-space: nowrap;
}
.ef-btn-save:hover:not([disabled]) {
  background: var(--cf-brand-dark, #4d7a00) !important;
}
.ef-btn-save[disabled] {
  background: var(--cf-border, #e5e7eb) !important;
  color: var(--cf-text-muted, #9ca3af) !important;
  box-shadow: none !important;
}
.ef-body {
  padding: 14px 20px;
  flex: 1;
}
.ef-grid {
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 16px;
  align-items: start;
}
@media (max-width: 1100px) {
  .ef-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .ef-body {
    padding: 10px 12px;
  }
  .ef-header {
    padding: 10px 14px;
  }
}
.ef-section {
  background: var(--cf-surface, #fff);
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius-lg, 12px);
  overflow: hidden;
  box-shadow: var(--cf-shadow-sm, 0 1px 3px rgba(0,0,0,0.08));
  margin-bottom: 10px;
}
.ef-section:last-child {
  margin-bottom: 0;
}
.ef-section__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: var(--cf-bg, #f4f6f8);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--cf-text, #1a1d23);
}
.ef-section__head mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  color: var(--cf-brand, #e3fd64);
  flex-shrink: 0;
}
.ef-section__head-extra {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ef-section__body {
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.ef-two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 16px;
}
@media (max-width: 600px) {
  .ef-two-col {
    grid-template-columns: 1fr;
  }
}
.ef-btn-secondary {
  font-size: 0.8rem !important;
  border-color: var(--cf-border, #e5e7eb) !important;
  color: var(--cf-text-muted, #6b7280) !important;
}
.ef-btn-secondary:hover {
  color: var(--cf-text, #1a1d23) !important;
  border-color: var(--cf-border-strong, #d1d5db) !important;
}
.ef-warn-text {
  font-size: 0.75rem;
  color: var(--cf-error, #dc2626);
}
.ef-line-wrap {
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius, 8px);
  padding: 10px 12px;
  margin-bottom: 8px;
  background: var(--cf-bg, #f4f6f8);
}
.ef-btn-remove-line {
  margin-top: 8px;
  font-size: 0.8rem !important;
  color: var(--cf-error, #dc2626) !important;
  border-color: rgba(220, 38, 38, 0.3) !important;
}
.ef-btn-remove-line:hover {
  background: #fef2f2 !important;
  border-color: var(--cf-error, #dc2626) !important;
}
.ef-line-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding: 4px 0 8px;
}
.ef-btn-add-line {
  font-size: 0.825rem !important;
  border-color: var(--cf-brand, #e3fd64) !important;
  color: var(--cf-brand-dark, #4d7a00) !important;
}
.ef-btn-add-line:hover {
  background: var(--cf-brand-light, #f9ffe0) !important;
}
.ef-totals {
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius, 8px);
  overflow: hidden;
  margin-top: 12px;
}
.ef-totals__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  font-size: 0.85rem;
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
}
.ef-totals__row:last-child {
  border-bottom: none;
}
.ef-totals__row--final {
  background: var(--cf-bg, #f4f6f8);
}
.ef-totals__label {
  color: var(--cf-text-muted, #6b7280);
  font-weight: 500;
}
.ef-totals__value {
  font-variant-numeric: tabular-nums;
  color: var(--cf-text, #1a1d23);
}
.ef-totals__value--total {
  font-size: 1rem;
  color: var(--cf-brand-dark, #4d7a00);
}
::ng-deep .ef-page .mat-mdc-form-field-subscript-wrapper {
  min-height: 0 !important;
}
::ng-deep .ef-page .mat-mdc-form-field-bottom-align::before {
  display: none !important;
}
.ef-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  gap: 18px;
}
.ef-loading__icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: var(--cf-brand, #e3fd64);
  opacity: 0.6;
}
.ef-loading__text {
  margin: 0;
  font-size: 0.875rem;
  color: var(--cf-text-muted, #6b7280);
}
.pf-saved-icon {
  color: #16a34a !important;
  font-size: 22px;
  width: 22px;
  height: 22px;
}
.pf-checkbox-wrap {
  display: flex;
  align-items: center;
  padding-top: 10px;
}
.pf-line-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}
.pf-line-product {
  font-size: 14px;
  font-weight: 600;
  color: var(--cf-text, #1a1d23);
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pf-line-total {
  font-size: 15px;
  font-weight: 700;
  color: var(--cf-brand-dark, #4d7a00);
  white-space: nowrap;
}
.pf-line-details {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}
.pf-chip {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  background: var(--cf-surface, #fff);
  border: 1px solid var(--cf-border, #e5e7eb);
  font-size: 12px;
  color: var(--cf-text, #1a1d23);
}
.pf-chip--tax {
  background: rgba(227, 253, 100, 0.08);
  border-color: rgba(227, 253, 100, 0.3);
  color: #92400e;
}
.pf-line-footer {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
}
.pf-btn-edit {
  font-size: 0.8rem !important;
  color: var(--cf-brand-dark, #4d7a00) !important;
  border-color: rgba(77, 122, 0, 0.4) !important;
}
.pf-btn-edit:hover {
  background: var(--cf-brand-light, #f9ffe0) !important;
}
.convert-card {
  border-radius: 16px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
  text-align: center;
  background: #fff;
}
.convert-card .convert-title {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #333;
}
.convert-card .convert-subtitle {
  font-size: 0.95rem;
  color: #666;
  margin: 0;
}
.convert-card .action-btn {
  min-width: 220px;
  padding: 10px 16px;
  font-weight: 500;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.convert-card .action-btn mat-icon {
  margin-right: 6px;
}
.convert-card .loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
/*# sourceMappingURL=preinvoice.component.css.map */
